
    import ModuleView from "@/components/module/ModuleView.vue";
    import ModuleIndex from "@/components/module/ModuleIndex.vue";
    import ModuleEdit from "@/components/module/ModuleEdit.vue";
    import ModuleCreate from "@/components/module/ModuleCreate.vue";

    const module = {
      path: "/module",
      name: "module",
      component: ModuleIndex,
      children: [
        { path: "view/:id", component: ModuleView , name: "moduleView" },
        { path: "edit/:id", component: ModuleEdit , name: "moduleEdit" },
        { path: "create", component: ModuleCreate , name: "moduleCreate"}
      ],
      meta: { authorize: [], requiresAuth: true }
    };

    export default module;
    